var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtvenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4078 32H50.3256L18.3257 0H5.40784L37.4078 32Z",
    fill: "#475569"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9622 1.63716e-06L55.8096 30.8474V0H47.4617V9.73909L37.7225 0L24.9622 1.63716e-06Z",
    fill: "#475569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.07129V31.9999H8.34782V22.2607L18.0869 31.9999H30.9287L0 1.07129Z",
    fill: "#475569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtvenue);
export default __webpack_public_path__ + "static/media/artvenue.c685424cf2db20dd216127967e873f1b.svg";
export { ForwardRef as ReactComponent };